import * as React from "react";

// @ts-ignore
import icon from "./bottomArrowWhite.svg";

interface IProps {
  className?: string;
}

export const BottomArrowWhite : React.SFC < IProps > = (props : IProps) => {
  return <img src={icon} className={props.className}/>;
};



// WEBPACK FOOTER //
// ./src/components/Icons/BottomArrow/BottomArrowWhite/bottomArrowWhite.tsx